export default {
  data() {
    return {
      __currentLanguage: window.__currentLanguage,
    }
  },
  methods: {
    byteToSize(bytes = 0) {
      if (bytes === 0) return '0 Bytes';
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
    },
    toSymbolName(symbol) {
      if (!symbol) return;
      return !symbol.split('').includes('-') ? symbol : symbol.split('').splice(0, symbol.split('').findIndex(x => x === '-')).join('').toString();
    },
    stepArray(min, max, step = 1) {
      return Array(Math.floor((max - min) / step) + 1).fill(min).map(((x, i) => (x + i * step)));
    },
    isFloat(val) { return !!(val % 1); },
    trimMessage(str, len) {
      if (!str) return '';
      return str.length > len ? str.substring(0, len).concat(' ...') : str;
    },
    isUndefinedOrNull(val) {
      return val === null || val === undefined || val === '';
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
};
